import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/theme-trp.css';
// import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';

import reactBeaconButton from '@trp-beacon-ui-kit/foundation/dist/react/beacon-button'
import reactBeaconControlGroup from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control-group'
import reactBeaconControl from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control'
import reactBeaconTooltip from '@trp-beacon-ui-kit/foundation/dist/react/beacon-tooltip'
import reactBeaconPopover from '@trp-beacon-ui-kit/foundation/dist/react/beacon-popover'
import reactBeaconModal from '@trp-beacon-ui-kit/foundation/dist/react/beacon-modal'
import reactBeaconTable from '@trp-beacon-ui-kit/foundation/dist/react/beacon-table'
import reactBeaconTableHeader from '@trp-beacon-ui-kit/foundation/dist/react/beacon-table-header'
import reactBeaconTableRecord from '@trp-beacon-ui-kit/foundation/dist/react/beacon-table-record'
import reactBeaconError from '@trp-beacon-ui-kit/foundation/dist/react/beacon-error'
import reactBeaconIconButton from '@trp-beacon-ui-kit/foundation/dist/react/beacon-icon-button'
import reactBeaconIcon from '@trp-beacon-ui-kit/foundation/dist/react/beacon-icon'
import reactBeaconNavigation from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation'
import reactBeaconNavigationButton from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-button'
import reactBeaconNavigationToolbelt from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-toolbelt'
import reactBeaconNavigationExpanded from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-expanded'
import reactBeaconNavigationPopover from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-popover'
//for the footer
import reactBeaconFooter from '@trp-beacon-ui-kit/foundation/dist/react/beacon-footer';
import reactBeaconNavigationFooter from '@trp-beacon-ui-kit/foundation/dist/react/beacon-navigation-footer';
import reactBeaconSocialLinkContainer from '@trp-beacon-ui-kit/foundation/dist/react/beacon-social-link-container';

// This is the name of your project
const projectNamePrefix = 'profile-spa';

//components
export const ProfileBeaconButton = reactBeaconButton(projectNamePrefix);
export const ProfileBeaconControlGroup= reactBeaconControlGroup(projectNamePrefix);
export const ProfileBeaconControl=reactBeaconControl(projectNamePrefix);
export const ProfileBeaconTooltip=reactBeaconTooltip(projectNamePrefix);
export const ProfileBeaconPopover=reactBeaconPopover(projectNamePrefix);
export const ProfileBeaconModal=reactBeaconModal(projectNamePrefix);
export const ProfileBeaconTable=reactBeaconTable(projectNamePrefix);
export const ProfileBeaconTableHeader=reactBeaconTableHeader(projectNamePrefix);
export const ProfileBeaconTableRecord=reactBeaconTableRecord(projectNamePrefix);
export const ProfileBeaconError=reactBeaconError(projectNamePrefix);
export const ProfileBeaconIconButton=reactBeaconIconButton(projectNamePrefix);
export const ProfileBeaconIcon =reactBeaconIcon(projectNamePrefix);
const projectName = 'rps-wrs';
export const ProfileBeaconNavigation = reactBeaconNavigation(projectName);
export const ProfileBeaconNavigationButton = reactBeaconNavigationButton(projectName);
export const ProfileBeaconNavigationToolbelt = reactBeaconNavigationToolbelt(projectName);
export const ProfileBeaconNavigationExpanded = reactBeaconNavigationExpanded(projectName);
export const ProfileBeaconNavigationPopover = reactBeaconNavigationPopover(projectName);
//for footer
export const ProfileBeaconFooter = reactBeaconFooter(projectName);
export const ProfileBeaconNavigationFooter = reactBeaconNavigationFooter(projectName);
export const ProfileBeaconSocialLinkContainer = reactBeaconSocialLinkContainer(projectName);
